import { Chip } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';
import { getEnvironmentsFromEntity } from './envUtils';

export const EntityEnvironmentsCard = () => {
  const { entity } = useEntity();
  const envs = getEnvironmentsFromEntity(entity);
  if (!envs.length) return null;
  return (
    <InfoCard title="Environments">
      {envs.map(env => (
        <Chip
          key={env}
          label={env}
          size="small"
          style={{ marginRight: 4, marginBottom: 4 }}
        />
      ))}
    </InfoCard>
  );
};
